export enum ProductFamilyEnum {
	NONE = 0,
	CORE = 1,
	IDD = 2,
	ROAMING = 3,
}

export const mapStringProductFamily: {
	[key: string]: ProductFamilyEnum;
} = {
	CORE: ProductFamilyEnum.CORE,
	IDD: ProductFamilyEnum.IDD,
	ROAMING: ProductFamilyEnum.ROAMING,
};
